import React, { Dispatch, SetStateAction } from 'react';

import Modal from '~/components/Modal';

import EditProfileFormik from './EditProfileFormik';
import { Container } from './styles';

interface EditProfileModal {
  open: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
}

const EditProfileModal = ({ setOpenModal, open }: EditProfileModal) => {
  return (
    <Container>
      <Modal open={open} modalState={(opened) => setOpenModal(opened)}>
        <EditProfileFormik setOpenModal={setOpenModal} />
      </Modal>
    </Container>
  );
};

export default EditProfileModal;
